<template>
     
     <div class="header">
            <nav class="navbar top-navbar navbar-expand-md navbar-light">
                <!-- Logo -->
                <div class="navbar-header">
                    <router-link class="navbar-brand" to="/dashboard">
                        <!-- Logo icon -->
                        <b><img src="static/assets/images/logo.png" alt="homepage" class="dark-logo" width="200"/></b>
                        <!--End Logo icon -->
                        <!-- Logo text -->
                      
                    </router-link>
                </div>
                <!-- End Logo -->
                <div class="navbar-collapse">
                    <!-- toggle and nav items -->
                    <ul class="navbar-nav mr-auto mt-md-0">
                        <!-- This is  -->
                        <!-- <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up text-muted  " href="javascript:void(0)"><i class="mdi mdi-menu"></i></a> </li>
                        <li class="nav-item m-l-10"> <a class="nav-link sidebartoggler hidden-sm-down text-muted  " href="javascript:void(0)"><i class="ti-menu"></i></a> </li> -->
                     
                    </ul>
                    <!-- User profile and search -->
                    <ul class="navbar-nav my-lg-0">

                       
                       
                        <!-- End Comment -->
                        <!-- Profile -->
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle text-muted  " href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{usernames}} 
                                 <img :src="profileImg === 'N/A' ? 'static/assets/images/avatar_2x.png' :  profileImg !== undefined ? `https://garage.brihantransport.co.ke/backend/public/assets/images/${profileImg}` : ''" class="profile-pic" />                                
                                </a>
                            <div class="dropdown-menu dropdown-menu-right animated zoomIn">
                                <ul class="dropdown-user">
                                    <li><router-link to="/profile"><i class="ti-user"></i> Profile</router-link></li>
                                    <li @click="signOut()"><router-link to=""><i class="fa fa-power-off"></i> Logout</router-link></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: mapGetters(["usernames","profileImg"]),
    methods:mapActions(["signOut"])
}
</script>


// WEBPACK FOOTER //
// src/layouts/header.vue